import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <ToastContainer />
    <Provider store={store}>
      <App />
    </Provider>
  </HashRouter>
);

reportWebVitals();



// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { BrowserRouter, HashRouter} from 'react-router-dom';
// import { Provider } from 'react-redux';
// import store from './redux/store'
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// let basename = "";
// if (process.env.NODE_ENV === "production") {
//   basename = "/single_vendor_admin/";
// }

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <>
//     <HashRouter>
//     <ToastContainer/>
//     <Provider store={store}>
//      <App />
//     </Provider>
//     </HashRouter> 
//   </>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
